export default __webpack_public_path__ + "static/media/smiley_5.5819648f.svg";